import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

const BobMenuItem = withStyles({
    root: {
        fontSize: '1.4rem'
    },
    checked: {},
})((props) => <MenuItem {...props} />);

export default BobMenuItem;
